module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAJklEQVR42mP8//8/AymAiYFEQHsNjAz/GYa6H4aDBpb/DEM+LQEAHxcGGwXVKrgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_acometida.png
// module id = H2qS
// module chunks = 0